import React, { useEffect, useState } from 'react';
import '../../App.css';
import InnerBanner from '../innerBanner/InnerBanner.jsx';
import MissonWrapp from '../missionWrapp/MissonWrapp.jsx';
import TeamBlock from '../teamBlock/TeamBlock.jsx';
import InterestWrapp from '../interestWrapp/InterestWrapp.jsx';
import RegisterWrapp from '../registeredWrapp/RegisterWrapp.jsx';
import axios from 'axios';
import { END_URL } from "../../config.js";
import Header from '../header/Header.jsx';
import OurFirm from '../our-firm/OurFirm.jsx';
import GlanceWrapp from '../glance/GlanceWrapp.jsx';
import CostWrapp from '../cost-fund/CostWrapp.jsx';
import FaqSection from '../faq-section/FaqSection.jsx';
import OptInfoWrapp from '../opt-info/OptInfoWrapp.jsx';
import FinalCTAWrapp from '../final-cta/FinalCTAWrapp.jsx';

function AboutPage() {
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    console.log("Component mounted. Fetching about page data...");

    const fetchData = async () => {
      try {
        const response = await axios.get(`${END_URL}about`);
        console.log("Data fetched successfully:", response.data);

        // Store full data
        setAboutData(response.data.data);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  if (!aboutData) {
    console.log("About data not loaded yet.");
    return;
  }

  console.log("About data is available. Rendering components...", aboutData);

  // Merge the first about record with class_action_summaries for GlanceWrapp
  const glanceData = {
    ...aboutData.about[0], // first about record
    class_action_summaries: aboutData.class_action_summaries, // include summaries
  };

  return (
    <>
      <InnerBanner data={aboutData.about[0]} />
      <OurFirm data={aboutData.about[0]} />
      <GlanceWrapp data={glanceData} /> {/* Pass merged object */}
      <MissonWrapp data={aboutData.about[0]} />
      <CostWrapp data={aboutData.about[0]}  />
      <FaqSection />
      <OptInfoWrapp data={aboutData.about[0]} />
      <FinalCTAWrapp data={aboutData.about[0]}/>
     
    </>
  );
}

export default AboutPage;
